import React from 'react';

import SegmentedNav from '../../../ui/segmented-nav';

interface RegistryItem {
  key: string;
  label: string;
  path: string;
  matchPaths: string[];
}

const registryItems: RegistryItem[] = [
  {
    key: 'taxonomy',
    label: 'Taxonomy Registry',
    path: '/v4/go-lab/intelligence/taxonomy',
    matchPaths: ['/v4/go-lab/intelligence/taxonomy'],
  },
  {
    key: 'prompts',
    label: 'Prompt Registry',
    path: '/v4/go-lab/intelligence/prompts',
    matchPaths: ['/v4/go-lab/intelligence/prompts'],
  },
];

const GOLabRegistryNav: React.FC = () => {
  return (
    <SegmentedNav
      ariaLabel="GO Lab registries"
      items={registryItems.map((item) => ({
        key: item.key,
        label: item.label,
        href: item.path,
        matchPaths: item.matchPaths,
      }))}
    />
  );
};

export default GOLabRegistryNav;
